export const OVERVIEW_LOADING = "overview/loading"
export const OVERVIEW_ERROR = "overview/error"
export const OVERVIEW_SUCCESS = "overview/success"